import React from 'react';
import Type from 'prop-types';
import cn from 'classnames';
import Div100vh from 'react-div-100vh';
import useStyles from './Page.styles';

const Page = props => {
  const { children, className, fullScreen, component: Component, ...other } = props;
  const classes = useStyles();
  const PageComponent = fullScreen ? Div100vh : Component;

  return (
    <PageComponent className={cn(classes.page, className)} {...other}>
      {children}
    </PageComponent>
  );
};

Page.propTypes = {
  fullScreen: Type.bool,
  className: Type.string,
  component: Type.elementType,
  children: Type.node.isRequired,
};

Page.defaultProps = {
  className: '',
  component: 'div',
  fullScreen: false,
};

export default Page;
